<template lang="pug">
.content-wrap
  .content-top
    .con
      .vip-wrapper(v-if="!loadVip")
        .vipinfo.pb-5(:class="{'epic-vip' : turnoverDetails[0].vip_next === null}")
          .iimg
            img(:src="'/new/img/vip/'+turnoverDetails[0].vip_id+'.png'")
            span {{ turnoverDetails[0].vip_name }}
            //- small -
          .ccon
            //- .t {{accountID}}
            .m
              template(v-if="turnoverDetails[0].vip_next !== null")
                .lwrap
                  .levelbar(v-if="showDepo")
                    .levmsg Deposit : 
                      span {{ $numeral(totalDeposit).format("0,0.00") }}
                      | / {{ $numeral(turnoverDetails[0].deposit_next).format("0,0.00") }}
                    .levbar
                      span(:style="'width:'+depoProgress+'%'")
                  .levelbar(v-if="showTo")
                    .levmsg Turnover : 
                      span {{ $numeral(totalTurnover).format("0,0.00") }}
                      | / {{ $numeral(turnoverDetails[0].turnover_next).format("0,0.00") }}
                    .levbar
                      span(:style="'width:'+toProgress+'%'")
                .lnext
                  i Next Level
                  img(:src="'/new/img/vip/'+turnoverDetails[0].vip_next+'.png'")
                  span {{ turnoverDetails[0].vip_name_next }}
        .af-tab
          .af-tabc
            router-link(to='deposit')
              img(src='/new/img/af/icon-depo.png')
              |  {{$t('ui.deposit')}}
          | |
          .af-tabc.aaa
            a(href="javascript:void(0)")
              img(src='/new/img/af/icon-with.png')
              |  {{$t('ui.withdrawal')}}
        .af-box
          .form-box.mb-3.mt-3
            .resbox-con
              .resbox-cusbox.wd.aaa
                .resbox-tabs
                  //- template(v-if="!startRender")
                    //- template(v-if="currentPromo==='SB'")
                      .tab-content
                        .tab-pane.fade.show.active
                          .withdrawal-description.text-uppercase {{ $t("ui.promotion_selected") }}: 
                            span.text-orange {{ promoDetails }} 
                              i.fa-solid.fa-circle-exclamation
                          .deposit-progress-text
                            .deposit-progress-left {{ $t("ui.progress") }}: 
                              span.text-orange {{promoAccumulate}}
                              | /{{promoTarget}}
                            .deposit-progress-right {{ $t('ui.withdraw_target_tips') }}
                          .progress-wrapper
                            .progress
                              .progress-bar(
                                role='progressbar' 
                                :style="'width:' + promoProgress + '%'" 
                                :aria-valuenow="promoProgress" 
                                aria-valuemin='0' 
                                aria-valuemax='100')
                              .percent {{promoProgress}}%
                          .mt-4.text-center
                            button.btn-submit(v-if="!loading" type='button' :class="{'disabled-grey': promoBind}" @click.stop="addWithdrawTicket(0)") {{ $t('ui.claim') }}
                            button.btn-submit.disabled-grey(v-else type='button')
                              i.fas.fa-duotone.fa-spinner.fa-spin-pulse
                    //- template(v-else)
                  .tab-content(v-if="promoBind")
                    .tab-pane.fade.show.active
                      .withdrawal-description.text-uppercase {{ $t("ui.promotion_selected") }}: 
                        span.text-danger {{ promoDetails }} 
                          i.fa-solid.fa-circle-exclamation
                      .deposit-progress-text
                        .deposit-progress-left {{ $t("ui.progress") }}: 
                          span.text-danger {{promoAccumulate}}
                          | /{{promoTarget}}
                        .deposit-progress-right {{ $t('ui.withdraw_target_tips') }}
                      .progress-wrapper
                        .progress
                          .progress-bar(
                            role='progressbar' 
                            :style="'width:' + promoProgress + '%'" 
                            :aria-valuenow="promoProgress" 
                            aria-valuemin='0' 
                            aria-valuemax='100')
                          .percent {{promoProgress}}%
                      
                  .tab-content(v-else)
                    .tab-pane.fade.show.active
                      .row.bank-select-wrap.mx-0
                        label.col-6.bank-wrap.bank-tap.py-2.button-radio(v-if="getEwallet" :class="[{'selected-option' : method === 'ewallet'}]")
                          input(type="radio" name="radio" value="ewallet"  v-model="method")
                          i.fa-solid.fa-wallet 
                          span &nbsp;{{$t('ui.bank_ewallet')}}
                          .checked-selected(v-if="method === 'ewallet'")
                            i.fa-solid.fa-check
                        label.col-6.bank-wrap.bank-tap.py-2.button-radio(v-if="getBankList" :class="[{'selected-option' : method === 'bank'}]" )
                          input(type="radio" name="radio" value="bank" v-model="method")
                          i.fas.fa-landmark
                          span &nbsp;{{$t('ui.bank')}}
                          .checked-selected(v-if="method === 'bank'")
                            i.fa-solid.fa-check
                      .mb-2.text-danger {{$t('ui.withdrawal_reminder')}}
                      template(v-if="method==='ewallet'")
                        .mb-2
                          label.col-form-label {{ $t("ui.bank_ewallet") }} :
                          select.form-control(v-model="ewalletId" @change="selectEwallet")
                            option(selected value="") {{ $t('ui.please_select_ewallet') }}
                            template(v-if="ewalletList.length > 0")
                              option(v-for="ewallet in ewalletList" :value="ewallet.aa") {{ewallet.bank_name}}
                        template(v-if="ewalletId !== ''")
                          .mb-2
                            label.col-form-label {{ $t("ui.bank_ewalletname") }} :
                            input.form-control.input-disabled(type='text' :placeholder="ewalletHolder" disabled)
                          .mb-2
                            label.col-form-label {{ $t("ui.bank_ewalletno") }} :
                            input.form-control.input-disabled(type='text' :placeholder="ewalletNo" disabled)
                      template(v-else)
                        .mb-2
                          label.col-form-label {{ $t("ui.bank_name") }} :
                          select.form-control(v-model="bankId" @change="selectBank")
                            option(selected value="") {{ $t('ui.please_select_bank') }}
                            template(v-if="bankList.length > 0")
                              option(v-for="bank in bankList" :value="bank.aa") {{bank.bank_name}}
                        template(v-if="bankId !== ''")
                          .mb-2
                            label.col-form-label {{ $t("ui.bank_accname") }} :
                            input.form-control.input-disabled(type='text' :placeholder="bankHolder" disabled)
                          .mb-2
                            label.col-form-label {{ $t("ui.bank_accno") }} :
                            input.form-control.input-disabled(type='text' :placeholder="bankNo" disabled)
                      .mb-2
                        label.col-form-label {{ $t('ui.amount') }} ({{$t('ui.min')}}: {{minWithdrawal}} {{$t('ui.max')}}: {{maxWithdrawal}})
                        input.form-control(type="text" v-model.trim="$v.withdrawAmount.$model" @input="onlyNum")
                      validation(:value="$v.withdrawAmount" :name="$t('ui.amount')" target="WITHDRAWAL")
                      .mt-4.text-center
                        button.btn-submit(v-if="!loading" type='button' @click.stop="addWithdrawTicket(1)") {{ $t('ui.submit') }}
                        button.btn-submit.disabled-grey(v-else type='button')
                          i.fas.fa-duotone.fa-spinner.fa-spin-pulse
                  //- template(v-else)
                    .text-center.my-2
                      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
        //- .af-box(v-else)
          .text-white.my-2.text-center
            i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black  
</template>
<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators"
import validation from "@/library/_validation.vue"
export default {
	components: {
    validation,
  },
	data(){
		return{
			promoTarget: "",
      promoDetails: "",
      promoProgress: "",
      promoAccumulate: "",
      promoBind: false,
      withdrawAmount: "",
      minWithdrawal: 0,
			maxWithdrawal : 0,
			bankHolder : "",
      bankNo : "",
      bankName : "",
      ewalletHolder : "",
      ewalletNo : "",
      feedback: {
        success: true,
        status: ""
      },
			loading: false,
      refreshPromoStatus: null,
      startRender:true,
      ready:false,
      method: "ewallet",
      bankList: [],
      ewalletList: [],
      bankId:"",
      ewalletId:"",
      finalBId: "",
      finalEId: "",
      currentPromo: "",
      turnoverDetails: [],
			depoProgress: 0,
      toProgress: 0,
      totalDeposit: 0,
      totalTurnover: 0,
      showDepo: false,
      showTo: false,
      loadVip: true,
		}
	},
	validations() {
    return {
      withdrawAmount: {
        required,
        minValue: minValue(this.minWithdrawal),
				maxValue: maxValue(this.maxWithdrawal)
      }
    };
  },
	computed:{
		accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
		getBankList() {
      return this.$store.getters.transaction
    },
    getEwallet(){
      return this.$store.getters.transactionEwallet
    }
	},
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    },
    method(newMethod, oldMethod){
      if(newMethod === 'ewallet'){
        this.bankId = ""
        this.bankHolder = ""
        this.bankNo = "",
        this.bankName = ""
      }else{
        this.ewalletId = ""
        this.ewalletHolder = ""
        this.ewalletNo = "",
        this.ewalletName = ""
      }
    }
  },
	created(){
    if(!this.getBankList && !this.getEwallet){
      this.$router.push({
        name:"setting",
        params:{
          "addBank": true
        }
      }).catch(error =>{})
    }else{
      if(!this.getEwallet){
        this.method = "bank"
      }
      this.ready = true
      this.getMemberEwallet()
      this.getMemberBankList()
    }
},
	beforeDestroy(){
		this.clearIntervalLoop()
	},
	mounted(){
    var vm = this
    this.getMemberVip()
		this.getPromotionStatus()
		this.getBankingMode()
		this.refreshPromoStatus = setInterval(() => {
			vm.getPromotionStatus()
		}, 10000)
		// if(this.getBankList.length > 0){
		// 	this.getDefaultBank()
		// }
    this.getBalance()
	},
	methods:{
    onlyNum(){
      this.withdrawAmount = this.withdrawAmount.replace(/[^0-9]/g, "")
    },
    selectBank(){
      this.bankList.filter(x => x.aa === this.bankId).forEach(y => {
        this.bankHolder = y.bank_acc_holder
        this.bankNo = y.bank_acc_no
        this.bankName = y.bank_name
        this.finalBId = y.bank_id
      })
    },
    selectEwallet(){
      this.ewalletList.filter(x => x.aa === this.ewalletId).forEach(y => {
        this.ewalletHolder = y.bank_acc_holder
        this.ewalletNo = y.bank_acc_no
        this.ewalletName = y.bank_name
        this.finalEId = y.bank_id
      })
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							// this.bankList = response.data
              response.data.filter(x=> x.status===true).forEach((y, index) => {
                y.aa = "b-" + index
                this.bankList.push(y)
              })
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getMemberEwallet(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberEwallet", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							// this.ewalletList = response.data
              response.data.filter(x=> x.status===true).forEach((y, index) => {
                y.aa = "e-" + index
                this.ewalletList.push(y)
              })
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
		clearIntervalLoop(){
      clearInterval(this.refreshPromoStatus);
    },
		getPromotionStatus() {
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let app_id = this.appID
        this.$store
          .dispatch("user/getPromotionStatus", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              let promoCriteria = response.data[0].a
              let accumulateWin = response.data[0].c
              let accumulateTurnover = response.data[0].d
              
              this.promoTarget = response.data[0].b
              this.promoDetails = response.data[0].e
              this.currentPromo = response.data[0].f

              if (promoCriteria == "TURNOVER") {
                var initialProgress = Number(((accumulateTurnover / this.promoTarget) * 100))
                // this.promoProgress = Number(((accumulateTurnover / this.promoTarget) * 100).toFixed(2))
                this.promoProgress = Number(((accumulateTurnover / this.promoTarget) * 100).toString().substring(0,5));
                if(initialProgress < 0){
                  this.promoProgress = 0;
                }
                this.promoAccumulate = response.data[0].d
                if(this.promoAccumulate < 0){
                  this.promoAccumulate = 0;
                }
                this.promoBind = (initialProgress < 100) ? true : false
              } else if (promoCriteria == "WIN") {
                var initialProgress = Number(((accumulateWin / this.promoTarget) * 100));
                // this.promoProgress = Number(((accumulateWin / this.promoTarget) * 100).toFixed(2))
                this.promoProgress = Number(((accumulateWin / this.promoTarget) * 100).toString().substring(0,5));
                if(initialProgress < 0){
                  this.promoProgress = 0;
                }
                this.promoAccumulate = response.data[0].c
                if(this.promoAccumulate < 0){
                  this.promoAccumulate = 0;
                }
                this.promoBind = (initialProgress < 100) ? true : false
              } else {
                this.promoBind = false
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.startRender = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }else{
              if(response.status.status == 0){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
                this.$router.push("/").catch(error =>{})
              }
            }
            this.startRender = false
          });
      }
    },
		getBankingMode() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBankingMode", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.minWithdrawal = (response.data.min_setting.filter(item => item.setting_key === "min_withdrawal"))[0].setting_value
              this.maxWithdrawal = (response.data.min_setting.filter(item => item.setting_key === "max_withdrawal"))[0].setting_value
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
		// getDefaultBank(){
    //   this.getBankList.filter(x => x.status == true && x.is_default == true).forEach(y => {
    //     this.defaultBankAcc = y.bank_acc_holder
    //     this.defaultBankNo = y.bank_acc_no
    //     this.defaultBankName = y.bank_name
    //     this.defaultBankId = this.tempBankId = y.bank_id
    //   })
    // },
		addWithdrawTicket(target){
      if(target===0){
        if(this.sessionToken) {
          var vm = this
          let account_id = this.accountID
          let withdrawal_amount = this.$store.getters.balance
          let auth_token = this.sessionToken
          if(this.ewalletList.length > 0){
            
            var bank_id = this.ewalletList[0].bank_id
            var bank_acc_no = this.ewalletList[0].bank_acc_no
          }else{
            var bank_id = this.bankList[0].bank_id
            var bank_acc_no = this.bankList[0].bank_acc_no
          }
          this.loading = true
          this.$store
            .dispatch("user/addWithdrawTicket", { account_id, withdrawal_amount, auth_token, bank_id, bank_acc_no })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
                // this.$router.push("/inbox").catch(error =>{})           
                // this.withdrawAmount = ""
                this.getBalance()
                this.$v.$reset()
                // this.reset()
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
              this.feedback.status = this.$t("error." + response.status)
            });
        }
      }else{
        this.$v.$touch()
        if (!this.$v.$invalid) {
          if(this.sessionToken) {
            var vm = this
            let account_id = this.accountID
            let withdrawal_amount = this.withdrawAmount
            let auth_token = this.sessionToken
            if(this.method === 'ewallet'){
              var bank_id= this.finalEId
              var bank_acc_no = this.ewalletNo 
            }else{
              var bank_id= this.finalBId
              var bank_acc_no = this.bankNo 
            }
            this.loading = true
            this.$store
              .dispatch("user/addWithdrawTicket", { account_id, withdrawal_amount, auth_token, bank_id, bank_acc_no })
              .then(response => {
                this.loading = false
                this.feedback.success = response.success
                this.feedback.status = response.status
                if (this.feedback.success == true) {
                  // if(response.isFreeC){
                  //   this.$swal({
                  //     title: vm.$tc("ui.attention"),
                  //     text: vm.$tc("ui.ftd_message"),
                  //     // showCancelButton: true,
                  //     type: "info",
                  //     confirmButtonText: vm.$tc("ui.claim_now"),
                  //     // cancelButtonText: vm.$tc("ui.reward"),
                  //   }).then(result => {
                  //     if (result.value) {
                  //       // vm.$router.push("/deposit").catch(error =>{})
                  //       vm.$router.push("/inbox").catch(error =>{})
                  //     }
                  //     // } else if (result.dismiss) {
                  //     //   vm.$router.push("/inbox").catch(error =>{})
                  //     // }
                  //   });
                  // }else{
                    // this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
                    $('#modal-review').modal("show")
                    this.$router.push({
                      name:"statement",
                      params:{
                        "checkTrans": true
                      }
                    }).catch(error =>{})
                  // }               
                  this.withdrawAmount = ""
                  this.getBalance()
                  this.$v.$reset()
                  // this.reset()
                } else {
                  this.feedback.status = this.$t("error." + response.status)
                  if((typeof response.status) != 'object'){
                    this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  }
                }
              })
              .catch(response => {
                this.loading = false
                this.feedback.success = false
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
                this.feedback.status = this.$t("error." + response.status)
              });
          }
        }
      } 
      
    },
    getBalance() {
      if (this.sessionToken) {
        //  var result = this.$helpers.apiConnect(this,"user/getBalance", {
        //   account_id : this.accountID,
        //   auth_token : this.sessionToken
        //  })
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    getMemberVip(){
      if (this.sessionToken) {
        this.loadVip = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberVip", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.turnoverDetails = response.data.deposit_turnover
              this.chart = response.data.next_level
              this.totalDeposit = this.turnoverDetails[0].starting_deposit + this.turnoverDetails[0].cycle_deposit
              this.totalTurnover = this.turnoverDetails[0].starting_turnover + this.turnoverDetails[0].cycle_turnover
              this.depoProgress = ( this.totalDeposit / this.turnoverDetails[0].deposit_next) * 100
              this.toProgress = (this.totalTurnover / this.turnoverDetails[0].turnover_next) * 100
              if(this.turnoverDetails[0].deposit_next !== 0){
                this.showDepo = true
              }
              if(this.turnoverDetails[0].turnover_next !== 0){
                this.showTo = true
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.loadVip = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.loadVip = false
          })
        }
    },
		reset() {
      this.promoTarget = ""
      this.promoDetails = ""
      this.promoProgress = ""
      this.promoAccumulate = ""
      this.withdrawAmount = 0
      this.minWithdrawal = 0
			this.maxWithdrawal = 0
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    },
	}
}
</script>
<style lang="scss" scoped>
.deposit-container{
	color: inherit;
  text-decoration: inherit;
}
</style>